import {
  Dialog,
  DialogMaxWidth,
  DialogVariant,
  Grid,
  Text,
  TextSize
} from '@focaldata/cin-ui-components'
import React from 'react'
import { getLanguageLabel } from '../../../utils/HelperFunctions'

interface Props {
  open: boolean
  languageCode: string | null
  busy: boolean
  onConfirm: () => void
  onClose: () => void
}

const RemoveLanguageDialog: React.FC<Props> = ({
  open,
  languageCode,
  busy,
  onConfirm,
  onClose
}) => {
  const label = languageCode ? getLanguageLabel(languageCode) : ''
  return (
    <Dialog
      open={open}
      onClose={busy ? () => undefined : onClose}
      title={`Remove ${label}?`}
      variant={DialogVariant.DoubleButton}
      maxWidth={DialogMaxWidth.Sm}
      primaryButtonText={busy ? 'Deleting…' : 'Delete translations'}
      primaryButtonClick={onConfirm}
      primaryButtonDisabled={busy || !languageCode}
      primaryButtonLoading={busy}
      secondaryButtonText="Cancel"
      secondaryButtonClick={onClose}
      secondaryButtonDisabled={busy}
    >
      <Grid container direction="column" spacing={1} style={{ padding: 16 }}>
        <Grid item>
          <Text size={TextSize.s}>
            All stored {label} translations across every survey question and
            custom screener will be permanently deleted. This cannot be undone.
          </Text>
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default RemoveLanguageDialog
